import React, { useEffect, useState } from 'react'
import { Box, Modal } from '@mui/material'
import { t } from 'i18next'
import LightTooltip from 'Components/LightTooltip'
import GenericModal from 'Components/GenericModal/GenericModal'
import { useDispatchFlowEligibility } from '../hooks/useDispatchFlowEligibility'
import './dispatchFlowSelectionModal.css'

export const DISPATCH_FLOW_OPTIONS = {
  dispatchAndInvoice: 'dispatchAndInvoice',
  dispatchOnly: 'dispatchOnly',
}

const DispatchFlowSelectionModal = ({
  open,
  onClose,
  companyId,
  branchOfficeId,
  branchName,
  warehouseId,
  fulfillmentPlanId,
  onConfirmOptionA,
  onConfirmOptionB,
}) => {
  const [selectedOption, setSelectedOption] = useState(
    DISPATCH_FLOW_OPTIONS.dispatchAndInvoice
  )
  const [showConfirmModal, setShowConfirmModal] = useState(false)

  const { isLoading, isOptionBEnabled } = useDispatchFlowEligibility({
    companyId,
    branchOfficeId,
    branchName,
    warehouseId,
    fulfillmentPlanId,
  })

  useEffect(() => {
    if (!isOptionBEnabled) {
      setSelectedOption(DISPATCH_FLOW_OPTIONS.dispatchAndInvoice)
    }
  }, [isOptionBEnabled])

  const handleContinue = () => {
    if (selectedOption === DISPATCH_FLOW_OPTIONS.dispatchOnly) {
      setShowConfirmModal(true)
      return
    }
    onConfirmOptionA()
  }

  const optionBTooltipTitle = isOptionBEnabled
    ? ''
    : isLoading
    ? t('RIGHT_SELECTION_MODAL.DISPATCH_FLOW.LOADING_TOOLTIP')
    : t('RIGHT_SELECTION_MODAL.DISPATCH_FLOW.DISABLED_TOOLTIP')

  return (
    <>
      <Modal
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 99999,
        }}
        open={open && !showConfirmModal}
        onClose={onClose}
        data-testid="modal-dispatch-flow-selection">
        <Box className="dispatch-flow-selection-modal-box">
          <h2 className="dispatch-flow-selection-title">
            {t('RIGHT_SELECTION_MODAL.DISPATCH_FLOW.TITLE')}
          </h2>
          <div className="dispatch-flow-selection-options">
            <label
              className="dispatch-flow-selection-option"
              data-testid="option-dispatch-and-invoice">
              <input
                type="radio"
                name="dispatch-flow-option"
                checked={
                  selectedOption === DISPATCH_FLOW_OPTIONS.dispatchAndInvoice
                }
                onChange={() =>
                  setSelectedOption(DISPATCH_FLOW_OPTIONS.dispatchAndInvoice)
                }
              />
              <span>
                {t('RIGHT_SELECTION_MODAL.DISPATCH_FLOW.OPTION_A_LABEL')}
              </span>
            </label>
            <LightTooltip
              arrow
              placement="right"
              componentsProps={{
                popper: { sx: { zIndex: 100000 } },
                tooltip: { sx: { maxWidth: 220 } },
              }}
              title={optionBTooltipTitle}>
              <span
                className="dispatch-flow-selection-option-wrapper"
                data-testid="option-dispatch-only-wrapper">
                <label
                  className={`dispatch-flow-selection-option${
                    isOptionBEnabled
                      ? ''
                      : ' dispatch-flow-selection-option-disabled'
                  }`}
                  data-testid="option-dispatch-only">
                  <input
                    type="radio"
                    name="dispatch-flow-option"
                    disabled={!isOptionBEnabled}
                    checked={
                      selectedOption === DISPATCH_FLOW_OPTIONS.dispatchOnly
                    }
                    onChange={() =>
                      setSelectedOption(DISPATCH_FLOW_OPTIONS.dispatchOnly)
                    }
                  />
                  <span>
                    {t('RIGHT_SELECTION_MODAL.DISPATCH_FLOW.OPTION_B_LABEL')}
                  </span>
                </label>
              </span>
            </LightTooltip>
          </div>
          <button
            className="dispatch-flow-selection-continue-button"
            onClick={handleContinue}
            data-testid="btn-dispatch-flow-continue">
            {t('RIGHT_SELECTION_MODAL.DISPATCH_FLOW.CONTINUE_BUTTON')}
          </button>
        </Box>
      </Modal>
      <Modal
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 99999,
        }}
        open={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        data-testid="modal-dispatch-flow-confirm">
        <Box>
          <GenericModal
            setIsOpen={setShowConfirmModal}
            text={t('RIGHT_SELECTION_MODAL.DISPATCH_FLOW.CONFIRM_MODAL_TEXT')}
            setConfirm={confirmed => {
              setShowConfirmModal(false)
              if (confirmed) onConfirmOptionB()
            }}
            showCaution
            hideCheck
          />
        </Box>
      </Modal>
    </>
  )
}

export default DispatchFlowSelectionModal
